import axios from './axios';

const CustomerService = {
   
    getCustomers: async (id,page) => {
        try {
            const response = await axios.get(`/customers?page=${page}&count=10`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    getCustomersCsv: async (id) => {
        try {
            const response = await axios.get(`/customers/`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    getCustomerDetail: async (restId,id) => {
        try {
            const response = await axios.get(`/customers/${id}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    getCustomerOrders: async (restId,id) => {
        try {
            const response = await axios.get(`/customers/${id}/orders`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    getCustomerFav: async (restId,id) => {
        try {
            const response = await axios.get(`/customers/${id}/favorites`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },

   
};

export default CustomerService;
